import React, { useMemo, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Cascader,
  ConfigProvider,
} from 'tea-component';
import classNames from 'classnames';
import { isEmptyValue, isValidEmail, isValidGsv } from '../_config/common';
import * as service from '@/pages/home/services/login';
import { MIN_PASSWORD_LEN, MAX_PASSWORD_LEN } from '../_config/constant';
import { getLocale, useIntl } from 'umi';
import { encryptedInfo } from '@/pages/home/utils/frontEncryption';
import { transformDataToTree, useGetOccupation } from '../hooks';
import { LANGUAGE_EN } from '@home/_config/config';
import { isEmpty, last } from 'lodash-es';
import { useSetState } from 'ahooks';

const { TextArea } = Input;

export default function EmailRegister(props: any) {
  const {
    getEmailRegisterBtn,
    onBack = () => console.log,
    onError = () => console.log,
    getEmailInfo = () => {}
  } = props;
  const { formatMessage } = useIntl();
  // 邮箱
  const [statusEmail, setStatusEmail] = useState<string | null>(null);
  const [valueEmail, setValueEmail] = useState<string>('');
  // 密码
  const [statusPadssword, setStatusPadssword] = useState<string | null>(null);
  const [valuePadssword, setValuePadssword] = useState<string>('');
  // 再次输入密码
  const [statusPadsswordAgin, setStatusPadsswordAgin] = useState<string | null>(null);
  const [valuePadsswordAgin, setValuePadsswordAgin] = useState<string>('');
  // 岗位
  const [occupationValue, setOccupationValue] = useSetState<{
    occupation: string[];
    statusOccupation: string | null;
  }>({
    occupation: [],
    statusOccupation: null
  });
  const { occupation, statusOccupation} = occupationValue;
  const [loading, setLoading] = useState(false);
  const isEN = getLocale() === LANGUAGE_EN;
  const { data: occupationDataList } = useGetOccupation();
  // 岗位数据
  const treeData = useMemo(() => transformDataToTree(occupationDataList as any[],  isEN), [occupationDataList, isEN]);

  const onEmailChangClick = (val: string) => {
    setValueEmail(val);
  };
  const onEmailBuleClick = () => {
    // 浏览器记录账户密码时，账户更新同时验证密码
    if (valuePadssword) {
      onPadsswordBuleClick();
    }

    if (isEmptyValue(valueEmail)) {
      setStatusEmail('dbh_login_no_work_email_entered');
      return false;
    }
    if (isValidEmail(valueEmail)) {
      setStatusEmail(null);
      return true;
    }
    setStatusEmail('dbh_login_email_format_error');
    return false;
  };

  const onPadsswordChangClick = (val: string) => {
    setValuePadssword(val);
  };
  const onPadsswordBuleClick = () => {
    /** 密码Again有值时也同步规则判断 */
    if (valuePadsswordAgin) {
      onAginPadsswordBuleClick();
    }
    if (!valuePadssword) {
      setStatusPadssword('dbh_login_no_password_enter');
      return false;
    }
    if (
      valuePadssword?.length < MIN_PASSWORD_LEN ||
      valuePadssword?.length > MAX_PASSWORD_LEN
    ) {
      setStatusPadssword('dbh_login_password_format');
      return false;
    } if (isValidGsv(valuePadssword)) {
      setStatusPadssword('dbh_login_format_gsv');
      return false;
    }
    setStatusPadssword(null);
    return true;
  };
  const getStatusPadsswordId = (id: string) => {
    if (id === 'dbh_login_password_format') {
      return formatMessage(
        { id: 'dbh_login_password_format' },
        { min: MIN_PASSWORD_LEN, max: MAX_PASSWORD_LEN },
      );
    }
    return formatMessage({ id });
  };

  // 再次输入密码
  const onAginPadsswordChangClick = (val: string) => {
    setValuePadsswordAgin(val);
  };
  const onAginPadsswordBuleClick = () => {
    if (!valuePadsswordAgin) {
      setStatusPadsswordAgin('dbh_login_no_password_enter');
      return false;
    }
    if (valuePadsswordAgin === valuePadssword) {
      setStatusPadsswordAgin(null);
      return true;
    }
    setStatusPadsswordAgin('dbh_login_different_passwords');
    return false;
  };

  // 申请原因
  const [statusReason, setStatusReason] = useState<string | null>(null);
  const [valueReason, setValueReason] = useState<string>('');

  const onReasonChangClick = (val: string) => {
    setValueReason(val);
    if (val.length > 500) {
      setStatusReason('dbh_login_more_reason_enter');
    }
  };
  const onReasonBuleClick = () => {
    if (isEmptyValue(valueReason)) {
      setStatusReason('dbh_login_no_reason_enter');
      return false;
    } if (valueReason?.length > 500) {
      setStatusReason('dbh_login_more_reason_enter');
      return false;
    }
    setStatusReason(null);
    return true;
  };
  const onOccupationChange = () => {
    if (isEmpty(occupation)){
      setOccupationValue({statusOccupation: 'dbh_login_please_enter_unentered_position'});
      return false;
    }
    return true;
  };
  // contiune按钮
  const onContinue = () => {
    // if (!valueOrganization) {
    //   setSuccessOrganization(false);
    //   setStatusOrganization('Please select organization');
    // }
    const _successOccupation = onOccupationChange();
    const _successEmail = onEmailBuleClick();
    const _successPadssword = onPadsswordBuleClick();
    const _successPadsswordAgin = onAginPadsswordBuleClick();
    const _successReason = onReasonBuleClick();

    if (
      !_successEmail ||
      !_successPadssword ||
      !_successPadsswordAgin ||
      !_successReason ||
      !_successOccupation
    ) {
      return;
    }
    handleRegister();
  };

  const handleRegister = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);
      const turnPassword = await encryptedInfo(valuePadssword);
      const res: any = await service.getEmailCode({
        email: valueEmail,
        password: turnPassword,
        // 注册页面获取验证码
        isRegister: true,
      });
      const expired = res?.expired;

      // 注册信息参数保存
      const params = {
        reason: valueReason,
        email: valueEmail,
        password: valuePadssword,
        // 注册页面获取验证码
        isRegister: true,
        occupation: last(occupation),
      };
      getEmailRegisterBtn(params, expired);

      setLoading(false);
    } catch (err: any) {
      getEmailInfo(valueEmail);
      onError(err?.msg, err?.code);
      setLoading(false);
    }
  };

  return (
    <div className="login-cont-email login-cont-email--register">
      <div className="login-cont">
        <div className="login-cont-title">
          {' '}
          {formatMessage({ id: 'dbh_login_signup_for_free' })}
        </div>
        <Form.Item
          required
          label={formatMessage({ id: 'dbh_login_occupation' })}
          message={
            statusOccupation
              ? formatMessage({ id: statusOccupation })
              : undefined
          }
          status={
            statusOccupation
              ? 'error'
              : undefined
          }
        >
          <ConfigProvider locale={isEN ? 'en' : 'zh'}>
            <Cascader
              clearable
              searchable
              type="menu"
              data={treeData}
              overlayClassName={classNames("login-cont-user-occupation-container", {
                'login-cont-user-occupation-container-en': isEN,
              })}
              placeholder={formatMessage({
                id: 'dbh_login_please_enter_occupation',
              })}
              valueRender={() => {
                const label =
                occupationDataList?.find(
                  (task: { uid: string; }) => task.uid === last(occupation),
                ) || {};
                const labelEn = isEN ? label?.name : label?.name_cn;
                const parentLabel = treeData?.find(
                  (task: { value: string; }) => task.value === label?.parent_uid,
                )?.label;
                if (!isEmpty(labelEn)) {
                  const fullText = `${parentLabel}: ${labelEn}`;
                  return fullText.length > 40 
                    ? `${fullText?.substring(0, 37)  }...` 
                    : fullText;
                }
                return null;
              }}
              onChange={(value) => {
                setOccupationValue({ occupation: value });
                setOccupationValue({ statusOccupation: '' });
              }}
            />
          </ConfigProvider>
        </Form.Item>
        {/* 邮箱 */}
        <Form.Item
          required={true}
          label={formatMessage({ id: 'dbh_login_word_email' })}
          status={
            /* successEmail ? 'success' : */ statusEmail ? 'error' : undefined
          }
          message={statusEmail ? formatMessage({ id: statusEmail }) : undefined}
        >
          <Input
            placeholder={formatMessage({
              id: 'dbh_login_word_email_placeholder',
            })}
            value={valueEmail}
            onChange={(val) => {
              onEmailChangClick(val);
            }}
            onBlur={onEmailBuleClick}
            autoComplete="off"
          />
        </Form.Item>
        {/* 密码 */}
        <Form.Item
          required={true}
          label={formatMessage({ id: 'dbh_login_password' })}
          status={
            /* successPadssword ? 'success' : */ statusPadssword
              ? 'error'
              : undefined
          }
          message={
            statusPadssword ? getStatusPadsswordId(statusPadssword) : undefined
          }
        >
          <Input
            type="password"
            placeholder={formatMessage({
              id: 'dbh_login_email_password_placeholder',
            })}
            value={valuePadssword}
            onChange={(val) => {
              onPadsswordChangClick(val);
            }}
            onBlur={onPadsswordBuleClick}
            autoComplete="new-password"
          />
        </Form.Item>
        {/* 再次输入密码 */}
        <Form.Item
          required={true}
          label={formatMessage({ id: 'dbh_login_password_confirm' })}
          status={
            /* successPadsswordAgin ? 'success' : */ statusPadsswordAgin
              ? 'error'
              : undefined
          }
          message={
            statusPadsswordAgin
              ? formatMessage({ id: statusPadsswordAgin })
              : undefined
          }
        >
          <Input
            required={true}
            type="password"
            placeholder={formatMessage({
              id: 'dbh_login_password_confirm_placeholder',
            })}
            value={valuePadsswordAgin}
            onChange={(val) => {
              onAginPadsswordChangClick(val);
            }}
            onBlur={onAginPadsswordBuleClick}
          />
        </Form.Item>
        {/* 申请原因 */}
        <Form.Item
          required={true}
          label={formatMessage({ id: 'dbh_login_reason_forapp' })}
          status={statusReason ? 'error' : undefined}
          message={
            statusReason ? formatMessage({ id: statusReason }) : undefined
          }
        >
          <TextArea
            maxLength={501}
            placeholder={formatMessage({
              id: 'dbh_login_reason_forapp_placeholder',
            })}
            value={valueReason}
            onChange={(val) => {
              onReasonChangClick(val);
            }}
            onBlur={onReasonBuleClick}
          />
        </Form.Item>

        <div className="login-cont-from-btn">
          <Button type="primary" onClick={onContinue} loading={loading}>
            {formatMessage({ id: 'dbh_login_continue' })}
          </Button>
          <Button type="link" onClick={onBack}>
            {formatMessage({ id: 'dbh_login_goback_tologin' })}
          </Button>
        </div>
      </div>
    </div>
  );
}
